import angular from 'angular';
import { Services } from '@Shared.Angular/@types/services';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';
import { SharedAngular } from '@Angular.Runner/@types/sharedAngular';

export class RouteAppConfigService {
  private routeConfigMapping: { [key: string]: () => boolean };

  constructor(
    private APP_CONFIG: Services.APP_CONFIG,
    private $state: angular.ui.IStateService
  ) {
    this.routeConfigMapping = this.getRouteConfigMapping();
  }

  handleRouteAvailability(route: string): boolean {
    const checkAvailability = this.routeConfigMapping[route];
    const isAvailable = checkAvailability ? checkAvailability() : true;

    if (isAvailable) {
      return true;
    }

    const fallbackRoute = this.getFallbackRoute();
    this.$state.go(fallbackRoute);

    return false;
  }

  private getRouteConfigMapping(): { [key: string]: () => boolean } {
    return {
      [STATE_MAPPINGS.flowsactive]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.flowstodo]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.flowsin]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.reports]: () =>
        this.APP_CONFIG.allowWorkflow || this.APP_CONFIG.enableReportsV2,
      [STATE_MAPPINGS.libraryworkflows]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.dashboard]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.analytics]: () => this.APP_CONFIG.allowWorkflow,
      [STATE_MAPPINGS.processmapsv2]: () => this.APP_CONFIG.allowProcessMap,
      [STATE_MAPPINGS.libraryprocessmaps]: () => this.APP_CONFIG.allowProcessMap
    };
  }

  private getFallbackRoute(): string {
    const defaultHomePageKey = this.APP_CONFIG.defaultHomePage;
    const defaultHomePageAllowedCheck =
      this.routeConfigMapping[STATE_MAPPINGS[defaultHomePageKey]];
    const isDefaultHomePageAllowed = defaultHomePageAllowedCheck
      ? defaultHomePageAllowedCheck()
      : true;

    let fallbackKey: string;

    if (isDefaultHomePageAllowed) {
      fallbackKey = defaultHomePageKey;
    } else if (this.APP_CONFIG.allowWorkflow) {
      fallbackKey = 'flowsactive';
    } else {
      fallbackKey = 'processmapsv2';
    }

    return STATE_MAPPINGS[fallbackKey];
  }
}

angular
  .module('flowingly.services')
  .factory('routeAppConfigService', [
    'APP_CONFIG',
    '$state',
    (APP_CONFIG: SharedAngular.APP_CONFIG, $state: angular.ui.IStateService) =>
      new RouteAppConfigService(APP_CONFIG, $state)
  ]);

export type RouteAppConfigServiceType = InstanceType<
  typeof RouteAppConfigService
>;
